import { useCallback, useState } from 'react';

/**
 * The hook is responsible for the speed of the playback.
 * The hook will store an internal state for the speed to notify its consumers about a change in its value.
 * The hook will expose the current playback's speed and a function for changing its value.
 * @param audioRef
 */
export var useSpeed = function useSpeed(audioRef) {
  var _useState = useState(1),
      rate = _useState[0],
      setRate = _useState[1];

  var setSpeed = useCallback(function (speed) {
    audioRef.current.playbackRate = speed;
    setRate(speed);
  }, [audioRef, setRate]);
  return {
    speed: rate,
    setSpeed: setSpeed
  };
};